var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionMark = function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A5",
    d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0-1.167A5.833 5.833 0 1 0 8 2.167a5.833 5.833 0 0 0 0 11.666m-.216-1.242c-.554 0-.95-.397-.95-.95 0-.561.396-.958.95-.958s.943.397.943.957c0 .554-.39.95-.943.95M5.55 6.037c.068-1.34.997-2.237 2.506-2.237 1.421 0 2.44.885 2.44 2.1 0 .859-.421 1.52-1.203 1.991-.653.386-.836.654-.836 1.193v.356l-.116.117h-.96l-.116-.117v-.503c-.006-.754.352-1.288 1.152-1.766.614-.377.826-.69.826-1.222 0-.625-.486-1.06-1.226-1.06-.76 0-1.241.435-1.297 1.163l-.116.107h-.937z"
  })));
};
export default SvgQuestionMark;